import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import LoadingCircle from './Global/LoadingCircle';

const Protected = ({ children }) => {
  const { user, loading } = UserAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>
        <LoadingCircle />
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/login' />;
  }

  return children;
};

export default Protected;